// removed by extract-text-webpack-plugin
module.exports = {"netProfitBar":"echartsHeight_netProfitBar_2Bvz5","reduceShareholder":"echartsHeight_reduceShareholder_2hezE","currentLiabilities":"echartsHeight_currentLiabilities_PrGYp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/echartsHeight.scss
// module id = 400
// module chunks = 0